import { computed } from "mobx";
import { FieldType, isEmptyOrWhitespace } from "@shoothill/core";
import { LoginModel } from "./LoginModel";
import { AccountStatus, ApiResult } from "@shoothill/core";
import { ViewModelBase } from "@shoothill/core";
import { AppUrls } from "../../AppUrls";
import { AccountStatusExtended } from "Globals/Stores/Domain";

export class LoginViewModel extends ViewModelBase<LoginModel> {
    constructor() {
        super(new LoginModel());
        //console.log("Login View Model Created");
        //EN - Havent figured out how to make this call work from the base model yet
        //This is only needed if you make use of the validation decorators
        this.setDecorators(LoginModel);
        //(window as any).model = this.model;
        //(window as any).proxy = proxy;
    }

    public login = async (): Promise<ApiResult<AccountStatusExtended>> => {
        let apiResult = await this.Post<AccountStatusExtended>(AppUrls.Server.Account.Login, this.getModel);
        return apiResult;
    };

    public async isFieldValid(fieldName: "emailAddress" | "password", value: any): Promise<boolean> {
        const { isValid, errorMessage } = await this.validateDecorators(fieldName);

        this.setError(fieldName, errorMessage);
        this.setValid(fieldName, isValid);

        return isValid;
    }

    //public afterUpdate: undefined;
    afterUpdate(fieldName: keyof FieldType<LoginModel>, value: any): void {
        //Do something like call an api or whatever/
        //Can use this instead of mobx reaction
        return;
    }
    //public beforeUpdate: undefined;
    beforeUpdate(fieldName: keyof FieldType<LoginModel>, value: any): any {
        //Do something and return the new value if you want or just use it to perform another action
        if (value === "something" && fieldName === "emailAddress") {
            value = "boo";
        }
        return value;
    }

    @computed
    public get isEmailAddressValid(): string {
        let retval = "";
        if (isEmptyOrWhitespace(this.getValue<string>("emailAddress"))) return "Email address is required";
        if (this.getValue<string>("emailAddress").length < 4) return "Email address must be greater than 4 characters";

        return retval;
    }

    @computed
    public get isPasswordValid(): string {
        let retval = "";
        if (isEmptyOrWhitespace(this.getValue("password") as string)) return "Password is required";
        if (this.getValue<string>("password").length < 4) return "Password must be greater than 4 characters";

        return retval;
    }
}
